import Lines from "./Lines";
import User from "./items/User";
interface ICindUserInStageCb {
    (item: any): boolean;
}

interface IfindUserInStage {
    (id: number, ICindUserInStageCb): void;
}

export default class Positions extends Lines {

    constructor(default_url: string, url: string) {
        super(default_url, url);
    }

    protected setChildrensPositions(current: User, currentGroup: Array<User>): void {
        var parentCenter: number = this.getParentCenterPositionX(current.fatherId, current.motherId);
        if ( parentCenter === null ) {
            return;
        }
        var groupCenter: number = this.getUsersCenterXPostion(currentGroup);
        if (groupCenter !== null && parentCenter !== null) {
            if (groupCenter !== parentCenter) {
                if (groupCenter < parentCenter) {
                    var distance: number = parentCenter - groupCenter;
                    //mobe right plus
                    for (var key in currentGroup) {
                        var item = currentGroup[key];
                        item.x += distance;
                    }
                } else if (groupCenter > parentCenter) {
                    var distance: number = groupCenter - parentCenter;
                    for (var key in currentGroup) {
                        var item = currentGroup[key];
                        item.x -= distance;
                    }
                }
            }
        }
    }

    protected setToChildrenCenterPositon(user:User){
        var childrens = [];
        for (var key in user.childrensIds) {
            this.findUserInStage(user.childrensIds[key], (item) => {
                childrens.push(item);
                return item;
            });
        }
        var couples = [ user ];
        for (var key in user.couplesIds) {
            this.findUserInStage(user.couplesIds[key], (item) => {
                couples.push(item);
                return item;
            });
        }
        var childrensCenterX:number = 0;
        if (  childrens.length > 1 ) {
            childrensCenterX = this.getUsersCenterXPostion(childrens);
        }else{
            if ( childrens[0] !== undefined ) {
                childrensCenterX = childrens[0].x;
            }else{
                console.log('nincs párja, így nincs első soros poziciója', user.fullName);
            }
        }
        var lastCoupleX:number = 0;
        for (var key in couples) {
            var couple = couples[key];
            if ( couples.length > 1 ) {
                //center
                if ( parseInt(key) === 0 ) {
                    couple.x = childrensCenterX - this.boxvVerticalDistance/2;
                }else{
                    couple.x = lastCoupleX + this.boxvVerticalDistance;
                }
                lastCoupleX = couple.x;
            }else{
                couple.x = childrensCenterX;
            }
        }
    }

    protected setToParentCenterPositon(user : User) {

        // FIXME: úgy kell megcsinálni mint a legfelsőt
        //return user;

        var parentsIds:Array<number> = [];

        if ( user.fatherId !== null ) {
            parentsIds.push(user.fatherId);
        }
        if ( user.motherId !== null ) {
            parentsIds.push(user.motherId);
        }

        var parents = [];
        for (var key in parentsIds) {
            this.findUserInStage(parentsIds[key], (item) => {
                parents.push(item);
                return item;
            });
        }
        var brothers = [ user ];
        for (var key in user.allBrothers) {
            this.findUserInStage(user.allBrothers[key], (item) => {
                brothers.push(item);
                return item;
            });
        }
        var parentsCenterX : number = 0;
        var brothersCenterX : number = 0;
        brothersCenterX = this.getUsersCenterXPostion(brothers);
        var distance = brothersCenterX - parentsCenterX;
        if ( parents.length > 0 ) {
            if (parents[0] !== undefined) {
                parentsCenterX = parents[0].x;
            }
            /*
            if (  parents.length > 1 ) {
                parentsCenterX = this.getUsersCenterXPostion(parents);
            }else{
                if (parents[0] !== undefined) {
                    parentsCenterX = parents[0].x;
                }
            }
            */
        }
        var lastBrotherX:number = 0;
        for (var key in brothers) {
            var brohter = brothers[key];
            if ( brothers.length > 1 ) {
                //center
                if ( parseInt(key) === 0 ) {
                    brohter.x = parentsCenterX - (this.boxvVerticalDistance * brothers.length) / 2 + this.boxvVerticalDistance/2;
                }else{
                    brohter.x = lastBrotherX + this.boxvVerticalDistance;
                }
                lastBrotherX = brohter.x;
            }else{
                brohter.x = parentsCenterX;
            }
        }
    }


    protected getUsersCenterXPostion(childrens: Array<User>): number {
        var leftX: number = null;
        var rightX: number = null;
        if (childrens.length === 0) {
            return;
        }
        if (childrens.length > 1) {
            for (var key in childrens) {
                var item = childrens[key];
                var leftItemRightX: number = item.x + item.width;
                if (leftX === null) {
                    leftX = leftItemRightX;
                    rightX = item.x;
                    continue;
                }
                if (leftItemRightX < leftX) {
                    leftX = leftItemRightX;
                    continue;
                }
                if (item.x > rightX) {
                    rightX = item.x;
                }
            }

            return leftX + ((rightX - leftX) / 2);
        } else {
            // ret =  childrens[0].x;
            return childrens[0].x + childrens[0].width / 2;
        }
    }

    // protected getParentsNextXPositons(childrens:Array<User>, father:User, mother:User):any{
    // 	//get children center position
    // 	var childrenCenterX:number = this.getChildrensCenterPostion(childrens);
    // 	console.log('getParentsNextXPositons from getChildrensCenterPostion');
    // 	var fatherNextX    :number = null;
    // 	var motherNextX    :number = null;
    // 	if ( father !== null && mother !== null ) {
    // 		//two parent
    // 		var parentDistanceX = mother.x - father.x;
    // 		fatherNextX         = childrenCenterX - parentDistanceX/2;
    // 		motherNextX         = childrenCenterX + parentDistanceX/2;
    // 	}else{
    // 		//single parent
    // 		if ( father !== null ) {
    // 			fatherNextX = childrenCenterX;
    // 		}else{
    // 			motherNextX = childrenCenterX;
    // 		}
    // 	}
    // 	return {
    // 		father: fatherNextX,
    // 		mother: motherNextX,
    // 	};
    // }

    protected iskExsistPlace(id_key: number, x: number, y: number): boolean {
        for (var key in this.current_map.item) {
            var item = this.current_map.item[key];
            // check fix positons
            if (id_key !== item.id_key) {
                if (x === item.x && y === item.y) {
                    return true;
                }
                //check hittest
                if (
                    (
                        x === item.x
                        ||
                        (
                            x > item.x
                            && x < (item.x + item.width)
                        )
                        ||
                        (
                            (x + item.width) > item.x
                            && x < item.x
                        )
                        ||
                        x === (item.x + item.width)
                        ||
                        (x + item.width) === item.x
                    )
                    && y === item.y
                ) {
                    return true;
                }
            }
        }
        return false;
    }

    private getParentCenterPositionX(fatherId: number, motherId: number): number {
        if (fatherId === null && motherId === null) {
            return null;
        }
        var center: number = null;
        var parents: Array<User> = [];
        if (fatherId !== null && motherId !== null) {
            if (fatherId !== null) {
                this.findUserInStage(fatherId, (item) => {
                    parents.push(item);
                    return item;
                });
            }
            if (motherId !== null) {
                this.findUserInStage(motherId, (item) => {
                    parents.push(item);
                    return item;
                });
            }
        }
        if (parents.length === 0) {
            return null;
        }
        return this.getUsersCenterXPostion(parents);
    }
}



// WEBPACK FOOTER //
// ./components/family_tree/Positions.ts